import { render, staticRenderFns } from "./Kanban.vue?vue&type=template&id=9b9e1dc2&"
import script from "./Kanban.vue?vue&type=script&lang=js&"
export * from "./Kanban.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev ii\\my work\\seo-team-flow\\vue templates\\Vuetify Soft UI Dashboard PRO\\seo-team-flow-ii\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9b9e1dc2')) {
      api.createRecord('9b9e1dc2', component.options)
    } else {
      api.reload('9b9e1dc2', component.options)
    }
    module.hot.accept("./Kanban.vue?vue&type=template&id=9b9e1dc2&", function () {
      api.rerender('9b9e1dc2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Configurations/Kanban.vue"
export default component.exports